import { getUTMParams } from "./hooks/getUTMParams";
import { editProfileSettings } from "app/actions/user";

export const handleUserUTMParams = async (dispatch: any) => {
  const utmParams = getUTMParams();
  const hasParams = Object.keys(utmParams).length > 0;

  if (!hasParams) {
    return;
  }

  try {
    await dispatch(editProfileSettings(utmParams));
  } catch (err) {
    console.error("Failed to update user UTM params", err);
  }
};
